import styled, { css } from 'styled-components';

export const ModalBodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    min-height: calc(100vh - var(--space-unit) * 11);
    ${(props) =>
        props.hasSubtitle &&
        css`
            min-height: calc(100vh - var(--space-unit) * 14);
        `}

    @media (min-width: 768px) {
        min-height: calc(var(--space-unit) * 25);
    }
`;

export const Content = styled.div`
    @media (min-width: 768px) {
        width: calc(var(--space-unit) * 52);
        ${(props) =>
            props.customWidth &&
            css`
                width: ${props.customWidth};
            `}
    }
`;

export const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
